import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { useEffect } from "react";
import Fade from "@mui/material/Fade";
import axios from "axios";
import { useState } from "react";
import { useMemo } from "react";
import { Divider, Menu, MenuItem } from "@mui/material";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button } from "@mui/material";
import BaseUrl from "../BaseUrl";
import { useHistory, useLocation } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Drawer from "@mui/material/Drawer";
import nocontactImage from "../Images/pana.svg";
import Loader from "../Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
};

export default function Contact() {
  const history = useHistory();
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [age, setAge] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [contacts, setContacts] = useState([]);
  const [openAlert, setAlertOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [open, setOpen] = useState(false);
  const [miniMenu, setMiniMenu] = useState(null);
  const openMiniMenu = Boolean(miniMenu);
  const [thChecked, setThChecked] = useState(false);
  const [nameListArr, setNameListArr] = useState([]);
  const [nameList, setNameList] = useState("");
  const [selectedList, setSelectedList] = useState("");
  const [nameListObj, setNameListObj] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [openAlert2, setAlertOpen2] = useState(false);
  const [searchedVal, setSearchedVal] = useState("");
  const location = useLocation();
  const [showToaster, setShowToaster] = useState(false);
  const [headCells, setHeadCells] = useState([]);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [terms, setTerms] = useState(false);
  const [isOpenContactForm, setIsOpenContactForm] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  const handleMiniMenu = (event) => {
    setMiniMenu(event.currentTarget);
  };
  const handleCloseMiniMenu = (e) => {
    setMiniMenu(null);
  };
  function deleteContacts() {
    if (contacts.length === selected.length) {
      axios
        .delete(
          `${BaseUrl.baseurl}/email-marketing/contact/delete-name-list/${
            userDetails && userDetails.details._id
          }/${location.pathname.split("/")[2]}`,
          {
            headers: {
              Authorization: `Bearear ${userDetails && userDetails.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            setShowToaster(true);
            toast.success(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
            setTimeout(() => {
              history.goBack();
            }, 3000);
          } else {
            setShowToaster(true);
            toast.error(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
            if (response.data.tokenExpire) {
              localStorage.removeItem("MailSenderuserDetails");
              window.location.reload();
            }
          }
        })
        .catch((err) => console.log("Error"));
    } else {
      let contactList = {
        contactDetails: selected.map((val) => {
          let vig = {
            email: val.Email,
            id: val._id,
          };
          return vig;
        }),
        nameListId: location.pathname.slice(10, location.pathname.length),
      };
      axios
        .put(
          `${BaseUrl.baseurl}/email-marketing/contact/remove-contact-email/${
            userDetails && userDetails.details._id
          }`,
          contactList,
          {
            headers: {
              Authorization: `Bearear ${userDetails && userDetails.token}`,
            },
          }
        )
        .then((response) => {
          // console.log("rres", response);
          console.log("rres=============>", selected);
          if (response.data.status) {
            setMiniMenu(null);
            setAlertOpen2(true);
            // getAllContactDetails()
            getAllNameList(contacts.length);
            toast.success(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
            setSelected([]);
          } else {
            setAlertOpen2(true);
            toast.error(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
            if (response.data.tokenExpire) {
              localStorage.removeItem("MailSenderuserDetails");
              window.location.reload();
            }
          }
        })
        .catch((err) => console.log("Error"));
    }
  }
  function getMiniMenuItem(index) {
    console.log("dhfhhhf", index, selected);
    if (index === "Delete") {
      console.log("inside if condition");
      deleteContacts();
    }
  }
  const handleChange6 = (event) => {
    setNameList(event.target.value);
    nameListArr.map((val) => {
      if (val.Name === event.target.value) {
        setNameListObj(val);
      }
    });
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleClose = () => setOpen(false);

  function addContactToNameList() {
    let nameListData = {
      contact: selected.map((val) => {
        let single = {
          Name: val.Name,
          Email: val.Email,
          Phone: val.Phone,
          SendingOption: val.SendingOption,
        };
        return single;
      }),
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/contact/add-contact-name-list/${
          userDetails && userDetails.details._id
        }/${nameListObj._id}`,
        nameListData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setOpen(false);
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllNameList(contacts.length+1000);
  }, [location.pathname]);
  function createContactListName() {
    let nameListData = {
      contact: [
        {
          Name: `${firstName} ${lastName}`,
          Email: email,
          Phone: `${phoneNumber}`,
          FirstName: firstName,
          LastName: lastName,
          CompanyName: "",
          Website: "",
          Subscriber: false,
          Blocked: false,
          SendingOption: "Unverified",
        },
      ],
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/contact/add-contact-name-list/${
          userDetails && userDetails.details._id
        }/${selectedList._id}`,
        nameListData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        console.log("rres", response);
        if (response.data.status) {
          setIsOpenContactForm(false);
          // getAllContactDetails()
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  const [listTitle, setListTitle] = useState("");
  function getAllNameList(count) {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/contact/get-name-list-by-id/${
          userDetails && userDetails.details._id
        }/${location.pathname.split("/")[2]}/${count}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          console.log("fnfnnfnfnf", response.data);
          // console.log("getting respected list contacts",listContacts)
          let rows = [];
          response.data.emailDetails.map((val, idx) => {
            val.checked = false;
            if (idx === 0) {
              if (val.FirstName !== "") {
                rows.push({
                  id: "FirstName",
                  numeric: false,
                  disablePadding: true,
                  label: "First Name",
                });
              }
              if (val.LastName !== "") {
                rows.push({
                  id: "LastName",
                  numeric: false,
                  disablePadding: true,
                  label: "Last Name",
                });
              }
              if (val.Email !== "") {
                rows.push({
                  id: "Email",
                  numeric: false,
                  disablePadding: true,
                  label: "Email",
                });
              }
              if (val.Phone !== "") {
                rows.push({
                  id: "Phone",
                  numeric: false,
                  disablePadding: true,
                  label: "Phone Number",
                });
              }
              if (val.Website !== "") {
                rows.push({
                  id: "Website",
                  numeric: false,
                  disablePadding: true,
                  label: "Website",
                });
              }
              if (val.CompanyName !== "") {
                rows.push({
                  id: "CompanyName",
                  numeric: false,
                  disablePadding: true,
                  label: "Company Name",
                });
              }
              rows.push({
                id: "Blocked",
                numeric: false,
                disablePadding: false,
                label: "Blocked",
              });
            }
          });
          setHeadCells(rows);
          console.log("rowsss", rows);
          setContacts([...contacts,...response.data.emailDetails]);
          setListTitle(response.data.details.Name);
          setShowLoader(false);
          // props.data(response.data.details.Name);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = contacts.map((contact) => contact.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    
    setPage(newPage);
    if((newPage+1)*rowsPerPage===contacts.length){
      getAllNameList(contacts.length+1000)
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - contacts.length) : 0;

  const visibleContacts = useMemo(
    () =>
      stableSort(contacts, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, contacts]
  );

  const EnhancedTableHead = (props) => {
    const { onSelectAllClick, numSelected, rowCount } = props;

    return (
      <TableHead>
        <TableRow sx={{ backgroundColor: "#FAFAFA" }}>
          {contacts.length !== 0 && (
            <TableCell padding="checkbox" sx={{ padding: "0px" }}>
              <Checkbox
                sx={{
                  color: "#1C485F",
                  "&.Mui-checked": {
                    color: "#1C485F",
                  },
                }}
                checked={thChecked}
                onClick={() => {
                  setThChecked(!thChecked);
                  contacts.map((val) => (val.checked = !thChecked));
                  setContacts([...contacts]);
                  contacts.map((val) => {
                    if (val.checked) {
                      setSelected([...contacts]);
                    } else {
                      setSelected([]);
                    }
                  });
                }}
              />
            </TableCell>
          )}

          {headCells.length !== 0 &&
            headCells.map((headCell) => (
              <TableCell
                key={headCell.id}
                align={headCell.numeric ? "center" : "left"}
                padding={
                  contacts.length === 0
                    ? "normal"
                    : headCell.disablePadding
                    ? "none"
                    : "normal"
                }
                sx={{
                  color: "#000",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 700,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  {headCell.label}
                  {/* {headCell.id === "dateAdded" && (
                  <div style={{ position: "relative" }}>
                    <button
                      aria-label="more"
                      id="long-button"
                      aria-controls={openMenu ? "long-menu" : undefined}
                      aria-expanded={openMenu ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={handleClick}
                      style={{ outline: "none", position: "relative"}}
                    >
                      <MoreVertIcon sx={{ fontSize: "17px" }} />
                    </button>
                    <Menu
                      id="long-menu"
                      MenuListProps={{
                        "aria-labelledby": "long-button",
                      }}
                      sx={{ position: "absolute", top: "30%", left: "75%" }}
                      anchorEl={anchorEl}
                      open={openMenu}
                      onClose={handleCloseMenu}
                      PaperProps={{
                        style: {
                          maxHeight: "370px",
                          width: "300px",
                        },
                      }}
                    >
                      {toggleActionData.map((data) => (
                        <>
                          <div
                            className="flex items-center justify-between"
                            style={{ padding: "0px 10px" }}
                          >
                            <MenuItem
                              className="flex items-center gap-2"
                              style={{
                                backgroundColor: "transparent",
                              }}
                            >
                              {data.svg}
                              <div
                                style={{
                                  backgroundColor: "transparent",
                                }}
                                onClick={handleCloseMenu}
                              >
                                <p
                                  className="text-sm font-medium"
                                  style={{
                                    color: "#868686",
                                    fontFamily: "Source Sans 3",
                                  }}
                                >
                                  {data.text}
                                </p>
                              </div>
                            </MenuItem>
                            {outTest()}
                          </div>
                          <Divider sx={{ my: 0.5 }} />
                        </>
                      ))}
                    </Menu>
                  </div>
                )} */}
                </Box>
              </TableCell>
            ))}
        </TableRow>
      </TableHead>
    );
  };

  const EnhacedActions = () => {
    return (
      <div
        className="bg-gray-100 border-b border-gray-300 action-row"
        style={{ width: "100%", padding: "4px 10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <Checkbox
                sx={{
                  color: "#1C485F",
                  "&.Mui-checked": {
                    color: "#1C485F",
                  },
                }}
                checked={thChecked}
                onClick={() => {
                  setThChecked(!thChecked);
                  contacts.map((val) => (val.checked = !thChecked));
                  setContacts([...contacts]);
                  contacts.map((val) => {
                    if (val.checked) {
                      setSelected([...contacts]);
                    } else {
                      setSelected([]);
                    }
                  });
                }}
              />
            </div>
            <button
              onClick={() => {
                setAlertOpen(true);
              }}
              className="bg-primary"
              style={{
                outline: "none",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                borderRadius: "4px",
                color: "#fff",
                padding: "12px 16px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M16.6908 2.06689L3.48242 15.2752"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.37474 10.8333C4.02474 10.025 3.81641 9.14998 3.81641 8.24998C3.81641 4.15832 7.33307 0.933316 11.3331 1.80832C12.5497 2.07498 13.6331 2.72498 14.4664 3.62498"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.8835 6.0835C16.9001 9.31683 15.2585 12.5668 12.9335 14.0585V15.0252C12.9335 15.2668 13.0168 15.8252 12.1835 15.8252H7.85013C6.9918 15.8252 7.10013 15.4668 7.10013 15.0252V14.0585C6.70013 13.8085 6.32513 13.5002 5.9668 13.1418"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Add to Block
            </button>
            <button
              onClick={() => {
                deleteContacts();
              }}
              style={{
                outline: "none",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                backgroundColor: "transparent",
                borderRadius: "4px",
                color: "#1C485F",
                padding: "12px 16px",
                border: "1px solid #1C485F",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.5 4.98356C14.725 4.70856 11.9333 4.56689 9.15 4.56689C7.5 4.56689 5.85 4.65023 4.2 4.81689L2.5 4.98356"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.08398 4.1415L7.26732 3.04984C7.40065 2.25817 7.50065 1.6665 8.90898 1.6665H11.0923C12.5007 1.6665 12.609 2.2915 12.734 3.05817L12.9173 4.1415"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.7077 7.6167L15.166 16.0084C15.0743 17.3167 14.9993 18.3334 12.6743 18.3334H7.32435C4.99935 18.3334 4.92435 17.3167 4.83268 16.0084L4.29102 7.6167"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.60742 13.75H11.3824"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.91602 10.4165H12.0827"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Remove
            </button>
          </div>
          <h1 className="seleceted-contact-title font-bold text-lg">
            {selected.length} Contacts Selected
          </h1>
        </div>
      </div>
    );
  };

  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h1"
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#4B4B4B",
                }}
              >
                Add to list
              </Typography>
              <Button
                type="button"
                style={{
                  display: "flex",
                  outline: "none",
                  transform: "none",
                  justifyContent: "flex-end",
                  padding: "0px",
                }}
                onClick={() => setOpen(false)}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Box>

            <Typography
              id="transition-modal-description"
              style={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#868686",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              In which list(s) do you want to add the {selected.length} selected
              contacts?
            </Typography>
            <Typography
              style={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#4B4B4B",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              List name
            </Typography>
            <FormControl
              variant="filled"
              style={{ minWidth: "100%", margin: "6px 0px" }}
            >
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={nameList}
                disableUnderline
                onChange={handleChange6}
                IconComponent={ArrowDropDownIcon}
                sx={{
                  color: "var(--color-dark-600, #727272)",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                  background: "var(--background-color, #FAFAFA)",
                }}
              >
                {nameListArr.length !== 0 &&
                  nameListArr.map((val) => {
                    return (
                      <MenuItem
                        sx={{
                          color: "var(--color-dark-600, #727272)",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "20px",
                        }}
                        value={val.Name}
                      >
                        {val.Name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <Button
                onClick={() => setOpen(false)}
                style={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  addContactToNameList();
                }}
                style={{
                  textTransform: "none",
                  // background: "#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
                className="bg-primary"
              >
                Add
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const handleBlockListContacts = () => {
    let nameListData = {
      contact: selected.map((val) => {
        let single = {
          email: val.Email,
          id: val._id,
        };
        return single;
      }),
      blockStatus: true,
    };
    // console.log("selected contacts",nameListData);
    axios
      .put(
        `${
          BaseUrl.baseurl
        }/email-marketing/contact/block-unblock-email-name-list/${
          userDetails && userDetails.details._id
        }/${location.pathname.slice(10, location.pathname.length)}`,
        nameListData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setAlertOpen(false);
          getAllNameList(contacts.length);
          setSelected([]);
          setThChecked(false);
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };

  const blockListModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openAlert}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openAlert}>
          <Box sx={style}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h1"
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#4B4B4B",
                }}
              >
                Add to Blocklist
              </Typography>
              <Button
                type="button"
                sx={{
                  display: "flex",
                  outline: "none !important",
                  transform: "none",
                  justifyContent: "flex-end",
                  padding: "0px",
                  "&:hover": {
                    background: "transparent",
                  },
                }}
                disableRipple
                disableElevation
                onClick={() => setAlertOpen(false)}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Box>

            <Typography
              id="transition-modal-description"
              style={{
                padding: "20px 0px",
                fontSize: "14px",
                color: "#868686",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              {`You are about to blocklist ${selected.length} selected contact.They will no longer
              be able to receive email campaigns but will still be displayed in
              your contacts.`}
            </Typography>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <Button
                onClick={() => setAlertOpen(false)}
                sx={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none !important",
                  color: "#1C485F",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  "&:hover": {
                    background: "transparent",
                  },
                }}
                disableRipple
                disableElevation
              >
                Cancel
              </Button>
              <button
                onClick={handleBlockListContacts}
                style={{
                  textTransform: "none",
                  background: "#FF3301",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: 5,
                }}
              >
                Okay
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
  };
  const createContactFrom = () => {
    return (
      <div>
        <Drawer
          anchor="right"
          open={isOpenContactForm}
          onClose={() => setIsOpenContactForm(false)}
        >
          <form
            style={{
              width: "500px",
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              paddingBottom: "12px",
            }}
            onSubmit={handleFormSubmit}
          >
            <div style={{ padding: "16px", borderBottom: "1px solid #DDD" }}>
              <h1
                style={{
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                }}
              >
                Create a contact
              </h1>
            </div>
            <div
              style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ padding: "10px 14px" }}>
                <div
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                    borderRadius: "6px",
                    padding: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(1, 1fr)",
                      gap: "14px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <label
                        style={{
                          fontFamily: "Source Sans 3",
                          color: "#393939",
                          fontSize: "12px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        First Name
                      </label>
                      <input
                        type="text"
                        value={firstName}
                        onChange={(e) => {
                          setFirstName(e.target.value);
                        }}
                        style={{
                          backgroundColor: "#FAFAFA",
                          padding: "13px 10px",
                          outline: "none",
                          borderRadius: "4px",
                          border: "1px solid #1C485F",
                        }}
                        placeholder="Enter First Name"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <label
                        style={{
                          fontFamily: "Source Sans 3",
                          color: "#393939",
                          fontSize: "12px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        value={lastName}
                        onChange={(e) => {
                          setLastName(e.target.value);
                        }}
                        style={{
                          backgroundColor: "#FAFAFA",
                          padding: "13px 10px",
                          outline: "none",
                          borderRadius: "4px",
                          border: "1px solid #1C485F",
                        }}
                        placeholder="Enter Last Name"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <label
                        style={{
                          fontFamily: "Source Sans 3",
                          color: "#393939",
                          fontSize: "12px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        Email
                      </label>
                      <input
                        type="text"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        style={{
                          backgroundColor: "#FAFAFA",
                          padding: "13px 10px",
                          outline: "none",
                          borderRadius: "4px",
                          border: "1px solid #1C485F",
                        }}
                        placeholder="Enter Email"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <label
                        style={{
                          fontFamily: "Source Sans 3",
                          color: "#393939",
                          fontSize: "12px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        Phone Number
                      </label>
                      <input
                        type="text"
                        maxLength={10}
                        value={phoneNumber}
                        onChange={(e) => {
                          setPhoneNumber(e.target.value);
                        }}
                        style={{
                          backgroundColor: "#FAFAFA",
                          padding: "13px 10px",
                          outline: "none",
                          borderRadius: "4px",
                          border: "1px solid #1C485F",
                        }}
                        placeholder="Enter Phone number"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <label
                        style={{
                          fontFamily: "Source Sans 3",
                          color: "#393939",
                          fontSize: "12px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        Lists
                      </label>
                      <FormControl
                        variant="filled"
                        style={{ minWidth: "100%", margin: "6px 0px" }}
                      >
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled"
                          value={selectedList}
                          disableUnderline
                          onChange={(e) => {
                            setSelectedList(e.target.value);
                          }}
                          IconComponent={ArrowDropDownIcon}
                          sx={{
                            color: "var(--color-dark-600, #727272)",
                            fontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "20px",
                            background: "var(--background-color, #FAFAFA)",
                          }}
                        >
                          {nameListArr.length !== 0 &&
                            nameListArr.map((val) => {
                              return (
                                <MenuItem
                                  sx={{
                                    color: "var(--color-dark-600, #727272)",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                  }}
                                  value={val}
                                >
                                  {val.Name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  borderTop: "1px solid #DDD",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "10px",
                  paddingTop: "7px",
                  paddingRight: "12px",
                }}
              >
                <button
                  onClick={() => setIsOpenContactForm(false)}
                  type="button"
                  style={{
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    border: "1px solid #1C485F",
                    color: "#1C485F",
                    backgroundColor: "transparent",
                    borderRadius: "4px",
                    padding: "7px 12px",
                    outline: "none",
                  }}
                >
                  Not Now
                </button>
                <button
                  onClick={() => {
                    createContactListName();
                  }}
                  type="submit"
                  style={{
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    color: "#fff",
                    // backgroundColor: "#1C485F",
                    borderRadius: "4px",
                    padding: "7px 12px",
                    outline: "none",
                  }}
                  className="bg-primary"
                >
                  Create
                </button>
              </div>
            </div>
          </form>
        </Drawer>
      </div>
    );
  };

  return (
    <div
      style={{
        background: "var(--background-color, #FAFAFA)",
        height: "100%",
        overflow: "auto",
        padding: "4px",
        borderRadius: "5px",
      }}
    >
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #DDD",
            boxShadow: "none",
            overflow: "hidden",
          }}
        >
          {selected.length >= 1 && EnhacedActions()}
          <TableContainer>
            <Box
              sx={{
                borderBottom: "1px solid #DDD",
                padding: "6px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Button
                disableRipple
                disableElevation
                sx={{
                  cursor: "default",
                  outline: "none !important",
                  borderBottom: "2px solid #1C485F",
                  borderRadius: 0,
                  color: "#1C485F",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <span
                  onClick={() => {
                    history.push("/Lists");
                  }}
                  style={{ cursor: "pointer", marginRight: 4 }}
                >
                  <KeyboardBackspaceIcon />
                </span>
                <Typography
                  style={{
                    color: "#1C485F",
                    fontSize: "15px",
                    fontWeight: 700,
                    fontFamily: "Source Sans 3",
                  }}
                  component="h2"
                >
                  {listTitle}
                </Typography>
              </Button>
            </Box>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={contacts.length}
              />

              {contacts.length !== 0 && (
                <TableBody>
                  {visibleContacts.map((contact, index) => {
                    return (
                      <TableRow
                        sx={{
                          backgroundColor: index % 2 === 0 ? "#FFF" : "#FAFAFA",
                        }}
                      >
                        <TableCell
                          padding="checkbox"
                          //  id={labelId}
                          sx={{ padding: "0px" }}
                        >
                          <Checkbox
                            sx={{
                              color: "#1C485F",
                              borderWidth: "1px",
                              "&.Mui-checked": {
                                color: "#1C485F",
                              },
                            }}
                            checked={contact.checked}
                            onClick={() => {
                              contacts.map((val) => {
                                if (val._id === contact._id) {
                                  val.checked = !val.checked;
                                }
                              });
                              setContacts([...contacts]);
                              if (contact.checked) {
                                setSelected((prevState) => [
                                  ...prevState,
                                  contact,
                                ]);
                              } else {
                                setSelected((prevState) =>
                                  prevState.filter(
                                    (selectedPlan) =>
                                      selectedPlan._id !== contact._id
                                  )
                                );
                              }
                            }}
                          />
                        </TableCell>
                        {headCells.map((val) => {
                          return (
                            <TableCell align="left" sx={{ padding: "0px" }}>
                              {contact[val.id] === ""
                                ? "--"
                                : contact[val.id] === true
                                ? "Yes"
                                : contact[val.id] === false
                                ? "No"
                                : contact[val.id]}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={5} />
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
            {showLoader ? (
              <div
                style={{
                  padding: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "30vh",
                }}
              >
                <Loader />
              </div>
            ) : (
              contacts.length === 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px 0px",
                    gap: "10px",
                  }}
                >
                  <img
                    src={nocontactImage}
                    alt="no-contact-pic"
                    style={{ height: "240px" }}
                    loading="lazy"
                  />
                  <p
                    style={{
                      color: "#393939",
                      fontSize: "22px",
                      fontWeight: 700,
                      fontFamily: "Source Sans 3",
                      fontStyle: "normal",
                      margin: "8px 0px",
                    }}
                  >
                    Nothing found
                  </p>
                  <p
                    style={{
                      color: "#868686",
                      fontSize: "13px",
                      fontWeight: 400,
                      fontFamily: "Source Sans 3",
                      fontStyle: "normal",
                      textAlign: "center",
                      marginTop: "0px",
                    }}
                  >
                    Oops! You don’t have any contacts yet
                    <br /> Please import contacts or create contacts.
                  </p>
                  <button
                    onClick={() => setIsOpenContactForm(true)}
                    style={{
                      // backgroundColor:"#1C485F",
                      color: "#FFF",
                      ontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 400,
                      padding: "8px 22px",
                      borderRadius: "4px",
                      outline: "none",
                    }}
                    className="bg-primary"
                  >
                    Create Contacts
                  </button>
                </div>
              )
            )}
          </TableContainer>
          {contacts.length !== 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <TablePagination
                rowsPerPageOptions={[25, 50, 100]}
                component="div"
                count={contacts.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          )}
        </Paper>
      </Box>
      {open && muiModal()}
      {isOpenContactForm && createContactFrom()}
      {openAlert && blockListModal()}
      {openAlert2 && <ToastContainer />}
      {showToaster && <ToastContainer />}
    </div>
  );
}
